import { render } from "./AboutCircles.vue?vue&type=template&id=2db38706&scoped=true"
import script from "./AboutCircles.vue?vue&type=script&lang=js"
export * from "./AboutCircles.vue?vue&type=script&lang=js"

import "./AboutCircles.vue?vue&type=style&index=0&id=2db38706&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db38706"]])

export default __exports__